import { render, staticRenderFns } from "./ProjectReceiveServerTable.vue?vue&type=template&id=858cdc38"
import script from "./ProjectReceiveServerTable.vue?vue&type=script&lang=js"
export * from "./ProjectReceiveServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports